module.exports = __webpack_public_path__ + "img/basin_position_info.47d0a812.png";